// extracted by mini-css-extract-plugin
module.exports = {"loadingWrapper":"loadingStake_loadingWrapper__2hvKt","loadingTab":"loadingStake_loadingTab__16mE1"};